import { serverRouteConfig } from "@server/server-route-config"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/api/oidc/jwks")(
  serverRouteConfig({
    server: {
      handlers: {
        GET: async ({ request }) => {
          const { handleShortLinksOidcJwks } = await import(
            "@api/features/short-links-sso/shortLinksOidcHandlers"
          )
          return handleShortLinksOidcJwks(request)
        },
      },
    },
  })
)
